import { useContext } from 'react';
import { FirmContext } from '../context/FirmContext';

const useFirm = () => useContext(FirmContext);

export default useFirm;
